(() => {
  const root = document.querySelector('[data-ira-tracker]');
  if (!root) return;
  if (root.dataset.learningUrl && ['#learn', '#questions'].includes(location.hash)) { location.replace(root.dataset.learningUrl + (location.hash === '#questions' ? '#learning-questions' : '')); return; }
  const tracker = root.querySelector('.ph-ira-tracker');
  const title = tracker && tracker.querySelector('#ira-tracker-title');
  if (title) {
    const body = document.createElement('div');
    body.id = 'ira-tracker-body';
    body.className = 'ph-tracker-body';
    while (title.nextSibling) body.appendChild(title.nextSibling);
    tracker.appendChild(body);
    const label = document.createElement('span');
    label.className = 'ph-tracker-desktop-title';
    label.textContent = title.textContent;
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ph-tracker-toggle';
    toggle.textContent = title.textContent;
    toggle.setAttribute('aria-controls', body.id);
    toggle.setAttribute('aria-expanded', 'true');
    title.replaceChildren(label, toggle);
    const mobile = matchMedia('(max-width: 760px)');
    let collapsed = true;
    function syncTracker() {
      const hidden = mobile.matches && collapsed;
      body.hidden = hidden;
      tracker.classList.toggle('is-collapsed', hidden);
      toggle.setAttribute('aria-expanded', String(!hidden));
    }
    toggle.addEventListener('click', () => { collapsed = !collapsed; syncTracker(); });
    mobile.addEventListener('change', syncTracker);
    syncTracker();
    tracker.dataset.trackerReady = "true";
  }
  const checks = [...root.querySelectorAll('[data-ira-check]')];
  const stages = [...root.querySelectorAll('[data-ira-step]')];
  const groups = [...root.querySelectorAll('[data-ira-group]')];
  const items = [...root.querySelectorAll('[data-tracker-item]')];
  const status = root.querySelector('[data-ira-status]');
  const note = root.querySelector('[data-ira-storage-note]');
  const next = root.querySelector('[data-ira-next]');
  const reset = root.querySelector('[data-ira-reset]');
  const key = 'pryce-house-ira-checklist-v2';
  const oldKey = 'pryce-house-ira-checklist-v1';
  function explain(text) { note.hidden = false; note.textContent = text; }
  function unavailable() { explain('Browser storage is unavailable. Your checks work on this page but may not survive a reload.'); }
  try {
    const saved = JSON.parse(localStorage.getItem(key) || 'null');
    if (saved && saved.version === 2 && saved.actions && typeof saved.actions === 'object') {
      checks.forEach(c => { c.checked = saved.actions[c.dataset.iraCheck] === true; });
    } else if (localStorage.getItem(oldKey)) {
      explain('This checklist now has individual actions. Earlier whole-step checks were not carried over; review and check the substeps you have completed.');
    }
  } catch (_) { unavailable(); }
  const findNext = () => checks.find(c => !c.checked);
  function openAction(check) {
    if (!check) return;
    const guide = root.querySelector('[data-ira-guide]');
    if (guide) guide.open = true;
    stages.forEach(s => { s.open = s.dataset.iraStep === check.dataset.stage; });
    groups.forEach(g => { g.open = g.dataset.iraGroup === check.dataset.stage; });
    const target = document.getElementById(check.dataset.target);
    if (target) {
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'center'});
    }
  }
  function render() {
    const upcoming = findNext();
    items.forEach((item, i) => { item.classList.toggle('is-next', checks[i] === upcoming); item.classList.toggle('is-done', checks[i].checked); });
    groups.forEach(group => {
      const children = checks.filter(c => c.dataset.stage === group.dataset.iraGroup);
      const count = children.filter(c => c.checked).length;
      const parent = group.querySelector('[data-ira-parent]');
      parent.checked = count === children.length;
      parent.indeterminate = count > 0 && count < children.length;
      group.querySelector('[data-ira-count]').textContent = count + ' of ' + children.length + ' actions checked';
      group.classList.toggle('is-next', !!upcoming && upcoming.dataset.stage === group.dataset.iraGroup);
      group.classList.toggle('is-done', parent.checked);
      group.open = !!upcoming && upcoming.dataset.stage === group.dataset.iraGroup;
    });
    next.disabled = !upcoming;
    status.textContent = upcoming ? root.dataset.nextPrefix + ' ' + upcoming.closest('label').querySelector('span').textContent : root.dataset.finished;
  }
  checks.forEach(check => check.addEventListener('change', () => {
    try {
      localStorage.setItem(key, JSON.stringify({version:2,actions:Object.fromEntries(checks.map(c => [c.dataset.iraCheck,c.checked]))}));
      localStorage.removeItem(oldKey);
    } catch (_) { unavailable(); }
    render();
    openAction(findNext());
  }));
  next.addEventListener('click', () => openAction(findNext()));
  reset.addEventListener('click', () => {
    checks.forEach(c => { c.checked = false; });
    note.hidden = true;
    try { localStorage.removeItem(key); localStorage.removeItem(oldKey); } catch (_) { unavailable(); }
    render();
    openAction(findNext());
  });
  render();
})();

